import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/device_components?include=device`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/device_components/${id}?include=device`, options)
        .then(response => {
            let deviceComponent = jsona.deserialize(response.data);
            delete deviceComponent.links;
            return deviceComponent;
        });
}

function add(deviceComponent) {
    const payload = jsona.serialize({
        stuff: deviceComponent,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/device_components`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(deviceComponent) {
    const payload = jsona.serialize({
        stuff: deviceComponent,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/device_components/${deviceComponent.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/device_components/${id}`, options);
}

function checkComponent(deviceComponent) {
    const payload = jsona.serialize({
        stuff: deviceComponent,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/device-component-replacement/check`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function replaceComponent(deviceComponent) {
    const payload = jsona.serialize({
        stuff: deviceComponent,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/device-component-replacement/replace`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

export default {
    list,
    get,
    add,
    update,
    destroy,
    checkComponent,
    replaceComponent
};